<template>
  <div class="v2-wrap">

    <login
        v-if="pageType == 1"
        :current-qa="currentQa"
        @loginSuccess="pageType = 2"
    />

    <before-main
        v-if="pageType == 2"
        :current-qa="currentQa"
        @enter="pageType = 3"
    />

    <shouye
        v-if="pageType == 3"
        :current-qa="currentQa"
        @enterBeforeExe="pageType = 4"
        @entryIdentify="pageType = 6"
    />

    <before-exe
        v-if="pageType == 4"
        :current-qa="currentQa"
        @startAns="pageType = 5"
        @back="pageType--"
        @home="pageType = 3"
    />

    <exe-qa
        v-if="pageType == 5"
        :current-qa="currentQa"
        @back="pageType--"
        @home="pageType = 3"
    />

    <ticket-entry-identify-main
        v-if="pageType == 6"
        :current-qa="currentQa"
        @back="pageType = 3"
    />

  </div>
</template>


<script setup>
import login from "@/views/examCenter/reportTax/page/login";
import BeforeMain from "./beforeMain.vue";
import Shouye from "./shouye.vue";
import BeforeExe from "./beforeExe.vue";
import ExeQa from "@/views/examCenter/taxDigitalAccountV2/exeQa.vue";
import ticketEntryIdentifyMain from './ticketEntryIdentifyMain.vue'
import {isAlReadyLogin} from "./taxDigAccLoginHandler.js";

const props = defineProps({
  currentQa: { // 当前题目信息对象
    required: true,
    type: Object,
  },
})

const pageType = ref(1) // 页面类型 1登录页  2首页前置页   3首页  4发票勾选认证前置页  5发票勾选认证--做题主页面
                        // 6发票入账标识--做题主页面

const getGrandchildValue = inject('getGrandchildValue');
getGrandchildValue.value.getResetData = () => {
  return {
    solution: ''
  }
}

onMounted(() => {
  if(isAlReadyLogin()) {
    pageType.value = 2
  }
})
</script>


<style scoped lang="scss">
.v2-wrap {
  height: 100%;
}
</style>
